interface PageMeta {
  title: string;
  description: string;
}

export const PAGE_META: Record<string, PageMeta> = {
  home: {
    title: 'LYREV - Creative Social Platform',
    description: 'LYREV is a modern social platform for creators to share and discover inspiring content.',
  },
  feed: {
    title: 'LYREV - Social Feed',
    description: 'Explore and share creative content on LYREV\'s social feed.',
  },
  contribute: {
    title: 'LYREV - Join Our Community',
    description: 'Join our vibrant community of creators and innovators at LYREV. Share your unique perspective and creative content.',
  },
  about: {
    title: 'LYREV - About Us',
    description: 'Learn about LYREV\'s mission to empower creators and build a vibrant creative community.',
  },
  contact: {
    title: 'LYREV - Contact Us',
    description: 'Get in touch with the LYREV team. We\'d love to hear from you!',
  },
  privacy: {
    title: 'LYREV - Privacy Policy',
    description: 'Learn about how LYREV protects your privacy and handles your data.',
  },
  admin: {
    title: 'LYREV - Admin Portal',
    description: 'Secure admin portal for LYREV platform management.',
  },
  adminDashboard: {
    title: 'LYREV - Admin Dashboard',
    description: 'Dashboard for managing LYREV platform content and users.',
  },
  adminFeed: {
    title: 'LYREV - Feed Management',
    description: 'Manage and moderate LYREV social feed content.',
  },
  adminApplications: {
    title: 'LYREV - Applications Manager',
    description: 'Review and manage contributor applications.',
  },
};
